import store from "@/store";

const PAGE_LOG_FORMAT = "native-app://send-log?page-id=";
const ACTION_LOG_FORMAT = "native-app://send-log-action?page-id=";
const LOG_FORMAT_CUSTOM_QUERY = "viewed-items=";

export const useLog = () => {
  /** ログIDの設定 */
  const setLogId = (logId: string) =>
    store.dispatch("common/updateLogId", logId);

  const outputLogs = (logformat: string, param: string | null) => {
    const logId = store.getters["common/getLogId"];
    if (!logId) return;

    const logStr = param
      ? logformat + logId + "&" + LOG_FORMAT_CUSTOM_QUERY + param
      : logformat + logId;

    location.href = encodeURI(logStr);
  };

  const outputPageLogs = (param: string | null) => {
    outputLogs(PAGE_LOG_FORMAT, param);
  };

  const outputActionLogs = (param: string | null) => {
    outputLogs(ACTION_LOG_FORMAT, param);
  };

  return {
    setLogId,
    outputPageLogs,
    outputActionLogs
  };
};
